export enum RouteNames {
  Onboarding = "Onboarding",
  Home = "Home",
  Assets = "Assets",
  AssetsRoot = "AssetsRoot",
  Spend = "Spend",
  Error = "Error",
  NewSpend = "NewSpend",
}
